import { HttpClient } from '@/data/protocols/http'
import { AxiosHttpClient } from '@/infra/http'
import { AxiosHttpAuthClient } from '@/infra/http/axios-http-auth-client'
import { makeSkillWebAuthorizeRedirectUrl } from '.'

export const makeHttpClient = (): HttpClient => new AxiosHttpClient()
export const makeHttpAuthClient = (): HttpClient => {
  return new AxiosHttpAuthClient(() => {
    window.location.href = makeSkillWebAuthorizeRedirectUrl()
  })
}
